
const contents = "query FeatureAccessInsightsClients($onBehalfOfUserId: ID) {\n  viewer {\n    canViewActivity(onBehalfOfUserId: $onBehalfOfUserId)\n    canViewLeadershipActivity(onBehalfOfUserId: $onBehalfOfUserId)\n    canViewNetworkActivity\n  }\n}\n";
const sha256Hash = "c40b28190b774f1b3c2f67e8a392b94de859fccad950cb15c36dcbd3ceed3bb2";
export default { contents: contents, sha256Hash: sha256Hash };
